/** Sort params that scope a my-deals list cache entry. */
export interface MyDealsListQuery {
  orderBy?: 'updated_at' | 'created_at';
  ascending?: boolean;
}

/**
 * Query key factory for the `/api/my-deals` (current-user submissions)
 * list. Separate namespace from {@link dealQueryKeys} because the data
 * shape (`MyDealDisplayData`) and access pattern (logged-in user's own
 * inbox) differ from the org-wide deals listing.
 */
export const myDealsQueryKeys = {
  all: ['my-deals'] as const,
  list: (query: MyDealsListQuery = {}) =>
    [...myDealsQueryKeys.all, 'list', query] as const,
  groups: (query: { ascending?: boolean; excludePlaced?: boolean } = {}) =>
    [...myDealsQueryKeys.all, 'groups', query] as const,
  /**
   * One level of the caller's PRIVATE My Deals folder tree (folders + submission
   * leaves) from `/api/my-deals/tree`. `parentId` omitted means the caller's My
   * Deals root children. Scoped by user id — My Docs is not org-scoped.
   */
  tree: (
    params: { parentId?: string; offset?: number } = {},
    userId?: string
  ) =>
    [
      ...myDealsQueryKeys.all,
      'tree',
      ...(userId ? [userId] : []),
      params.parentId ?? 'root',
      ...(params.offset !== undefined ? [`offset=${params.offset}`] : []),
    ] as const,
} as const;
